<template>
  <div class="voice page-wrapper">
    <el-image
      class="banner"
      style="width: 100%;"
      :src="require('../../assets/voice_banner.png')"
      fit="scale-down">
    </el-image>
    <div class="container">
      <div class="row">
        <el-row class="section1" :gutter="24">
          <el-col :span="12" :xs="{ span: 24 }">
            <img src="../../assets/voice_ys.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{ span: 24 }">
            <h3>
              大于智能语音解决方案
            </h3>
            <p>
              全球领先的智能语音端到端全链路解决方案、支持基于小米小爱，百度小度，亚马逊AlexaEcho，京东叮咚，京东小京鱼，阿里天猫精灵，华为小艺，Vivo Jovi物联等语音平台，提供丰富的技能服务和智能设备控制能力。支持基于大于语音模组，提供一站式软硬件和声学设计服务。
            </p>
          </el-col>
        </el-row>
        <h2 class="section2">我们的优势</h2>
        <el-row class="section3">
          <el-col :span="6" :xs="{span: 12}" class="feature">
            <img src="../../assets/voice_quh.png" alt="">
            <label for="">全球化</label>
          </el-col>
          <el-col :span="6" :xs="{span: 12}" class="feature">
            <img src="../../assets/voice_dpl.png" alt="">
            <label for="">多品类</label>
          </el-col>
          <el-col :span="6" :xs="{span: 12}" class="feature">
            <img src="../../assets/voice_dzd.png" alt="">
            <label for="">多终端</label>
          </el-col>
          <el-col :span="6" :xs="{span: 12}" class="feature">
            <img src="../../assets/voice_qll.png" alt="">
            <label for="">全链路</label>
          </el-col>
        </el-row>
        <h2 class="section4">我们已接入的第三方语音服务</h2>
        <el-row class="section5">
          <el-col :span="4" :xs="{ span: 6 }">
            <el-image :src="require('../../assets/xiaoai_tongxue.png')" fit="scale-down"> </el-image>
            <label for="">小爱同学</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/xiaoyi_zhushou.png')" fit="scale-down"> </el-image>
            <label for="">小艺语音助手</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/siri.png')" fit="scale-down"> </el-image>
            <label for="">苹果语音助手</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6 }">
            <el-image :src="require('../../assets/tiaomao_jingling.png')" fit="scale-down"> </el-image>
            <label for="">天猫精灵</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/xiaodu.png')" fit="scale-down"> </el-image>
            <label for="">小度音箱</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/huawei_hilink.png')" fit="scale-down"> </el-image>
            <label for="">华为HiLink</label>
          </el-col>
        </el-row>
        <el-row class="section6">
          <el-col :span="4" :xs="{ span: 6 }">
            <el-image :src="require('../../assets/jd_dingdong.png')" fit="scale-down"> </el-image>
            <label for="">叮咚音箱</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/jd_jingyuzuo.png')" fit="scale-down"> </el-image>
            <label for="">鲸鱼座智能音箱</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/vivo_xiaov.png')" fit="scale-down"> </el-image>
            <label for="">Jovi语音助手</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6 }">
            <el-image :src="require('../../assets/oppo_xiaoo.png')" fit="scale-down"> </el-image>
            <label for="">小欧语音助手</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/google_assistant.png')" fit="scale-down"> </el-image>
            <label for="">谷歌语音助手</label>
          </el-col>
          <el-col :span="4" :xs="{ span: 6, offset: 3 }">
            <el-image :src="require('../../assets/amazon_alexa.png')" fit="scale-down"> </el-image>
            <label for="">亚马逊语音助手</label>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  margin: 40px 0;
  .el-col {
    position: relative;
    img {
      width: 100%;
      max-width: 500px;
    }
  }
  .el-col:last-child {
    h3 {
      font-size: 24px;
      font-weight: normal;
      margin: 40px 0;
      text-align: center;
    }
    p {
      line-height: 1.66;
    }
  }
}
.section2 {
  margin: 80px 0 40px 0;
  text-align: center;
  font-weight: normal;
}
.section3 {

  & > .el-col {
    
    margin: var(--margin-normal) 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    label {
      display: block;
      text-align: center;
      margin-top: 12px;
    }
  }
}
.section4 {
  text-align: center;
  margin: 80px 0 40px;
  font-weight: normal;
}
.section5,
.section6 {
  .el-col {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: var(--margin-normal);
    overflow: visible;
    height: 110px;
  }
  .el-image {
    height: 80px;
  }
  label {
    display: block;
    text-align: center;
    margin-top: 12px;
    font-size: var(--font-normal-size);
    white-space: nowrap;
    overflow: visible;
  }
}

.section6 {
  margin: 24px 0 80px;
}

@media screen and (max-width: 991px) {
  .section3 {
    img {
      height: 67px;
    }
  }
  .section5 .el-image, .section6 .el-image {
    height: 56px;
  }
}
</style>